import React from 'react'
import { Button } from 'react-bootstrap'
import hubspotLogo from 'images/hubspot-logo.svg'

interface HubSpotButtonProps {
  url: string
  size?: 'sm' | 'lg'
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | 'link'
  className?: string
  style?: React.CSSProperties
}

const HubSpotButton: React.FC<HubSpotButtonProps> = ({
  url,
  size = 'sm',
  variant = 'primary',
  className,
  style,
}) => {
  const getEntityType = (url: string): string => {
    // Check for new URL format: /record/[object-type]/[object-id]
    if (url.includes('/record/0-1/')) return 'HubSpot Contact'
    if (url.includes('/record/0-2/')) return 'HubSpot Company'
    if (url.includes('/record/0-3/')) return 'HubSpot Deal'
    if (url.includes('/record/0-5/')) return 'HubSpot Ticket'
    // Check for legacy URL formats
    if (url.includes('/deal/')) return 'HubSpot Deal'
    if (url.includes('/contact/')) return 'HubSpot Contact'
    if (url.includes('/company/')) return 'HubSpot Company'
    return 'HubSpot'
  }

  return (
    <Button
      variant={variant}
      size={size}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        ...style,
      }}
      as="a"
    >
      <img
        src={hubspotLogo}
        alt="HubSpot"
        style={{ width: '16px', height: '16px' }}
      />
      {getEntityType(url)}
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginLeft: '4px' }}
      >
        <path
          d="M10.5 1.5L1.5 10.5M10.5 1.5H4.5M10.5 1.5V7.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  )
}

export default HubSpotButton
